import { render, staticRenderFns } from "./PartnerModal.vue?vue&type=template&id=65fc79af&scoped=true&"
import script from "./PartnerModal.vue?vue&type=script&lang=js&"
export * from "./PartnerModal.vue?vue&type=script&lang=js&"
import style0 from "./PartnerModal.vue?vue&type=style&index=0&id=65fc79af&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65fc79af",
  null
  
)

export default component.exports